export default "__VITE_ASSET__BFWM3NoL__"